import {
  EXCHANGE_RATE_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
  EXCHANGE_RATE_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD,
  EXCHANGE_RATE_MASSIVE_UPLOAD_REQUEST_VERIFY,
  EXCHANGE_RATE_MASSIVE_UPLOAD_SET_VERIFY,
  EXCHANGE_RATE_MASSIVE_UPLOAD_CLEAR_VERIFY,
  EXCHANGE_RATE_MASSIVE_UPLOAD_REQUEST_UPLOAD,
  EXCHANGE_RATE_MASSIVE_UPLOAD_SET_UPLOAD,
  EXCHANGE_RATE_MASSIVE_UPLOAD_CLEAR_UPLOAD,
} from '../actions';

function usersMassiveUploadReducer(state = {}, action) {
  const { type } = action;

  switch (type) {
    case EXCHANGE_RATE_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: action.payload,
      };

    case EXCHANGE_RATE_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: null,
      };

    case EXCHANGE_RATE_MASSIVE_UPLOAD_REQUEST_VERIFY:
      return {
        ...state,
        isLoading: true,
        verify: null,
      };

    case EXCHANGE_RATE_MASSIVE_UPLOAD_SET_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: action.payload,
      };

    case EXCHANGE_RATE_MASSIVE_UPLOAD_CLEAR_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: null,
      };

    case EXCHANGE_RATE_MASSIVE_UPLOAD_REQUEST_UPLOAD:
      return {
        ...state,
        isLoading: true,
        upload: null,
      };

    case EXCHANGE_RATE_MASSIVE_UPLOAD_SET_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: action.payload,
      };

    case EXCHANGE_RATE_MASSIVE_UPLOAD_CLEAR_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: null,
      };

    default:
      return state;
  }
}

export default usersMassiveUploadReducer;
